import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 30"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M1.707.293.293 1.707l28 28 1.414-1.414L21 19.586V12.66a5.999 5.999 0 0 0-.855-3.086L18 6h-6l-1.719 2.867L1.707.293zM12 2a1 1 0 0 0 0 2h6a1 1 0 0 0 0-2h-6zM9 13.191V26a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-.809l-12-12z" }, null, -1)
  ])))
}
export default { render: render }